export const ManageRolesConfigConsts = {
  INTERNAL_USERS_TAB_KEY: "interalUserRoles",
  INTERNAL_USERS_LABEL: "Internal User Roles",
  EXTERNAL_USERS_TAB_KEY: "externalUserRoles",
  EXTERNAL_USERS_LABEL: "External User Roles",
  TAB_TYPE: "line",
  TAB_SIZE: "medium",
  TAB_POSITION: "top",
};
